import React, { useState } from "react";
import styled from "styled-components";
import { Wrap, Frame, Nav, NavItem } from "./styles";
import Logo from "../Logo";
import Humburger from "./Humburger";
import { useWindowSize } from "@src/utils/useWindowSize";
import settings from "@src/settings";
import SpMenu from "./SpMenu";

interface Props {
	navInfo: {
		label: string;
		href: string;
	}[];
	className?: string;
}

const Header: React.FC<Props> = (props) => {
	const { navInfo, className } = props;
	const { width: windowW } = useWindowSize();
	const handleNavigation = (event: React.MouseEvent<HTMLAnchorElement>) => {
		const eventTarget = event.target as HTMLAnchorElement;
		const href = eventTarget.getAttribute("href");
		if (href && href.match(/^#/)) {
			event.preventDefault();
			const target =
				eventTarget && eventTarget.getAttribute("href")
					? (document.querySelector(href) as HTMLElement)
					: null;
			if (target) {
				window.scrollTo({
					top: target.offsetTop,
					behavior: "smooth",
				});
			}
		}
	};
	const [spMenuVisible, setSpMenuVisvle] = useState(false);
	const toggleSpMenu = () => setSpMenuVisvle(!spMenuVisible);
	return (
		<Wrap className={className}>
			<Frame spMenuVisible={spMenuVisible}>
				<Logo
					markOnly={windowW !== null && windowW <= settings.breakpoint.lg}
				/>
				<Nav>
					{navInfo.map((val, index) => (
						<NavItem
							href={val.href}
							key={`headerNavItem${index}`}
							onClick={handleNavigation}
						>
							{val.label}
						</NavItem>
					))}
				</Nav>
				<Humburger onClick={toggleSpMenu} toClose={spMenuVisible} />
				<SpMenu
					navInfo={navInfo}
					handleNavigation={handleNavigation}
					closeMenu={toggleSpMenu}
				/>
			</Frame>
		</Wrap>
	);
};

export default styled(Header)``;
